import React from "react";
import { createRoot } from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/provider";
import theme from "theme/theme.js";
import App from "App";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ChakraProvider theme={theme} resetCss={false} position="relative">
    <App />
  </ChakraProvider>
);
